/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {NotificationState} from '../reducers/user-prompt';

// input selectors ...
const selectNotification = ({userPrompt: {notification}}) => notification;

// output selectors ...
export const notificationSelector = createSelector(selectNotification,
  (notification: NotificationState): any => notification
);
